module.exports = __webpack_public_path__ + "static/media/landing-banner-m.5ea7c8f7.svg";